export const transactionTypes = [
  "Bonus",
  "Fine",
  "Salary",
  "Expense",
  "Purchase",
  "Refund",
]
